<footer class="w-full bg-[#212529] text-white">
  <div class="mx-auto max-w-[1320px] px-4 sm:px-6 lg:px-8">
    <div class="grid grid-cols-1 gap-10 py-10 sm:py-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,3fr)_minmax(16rem,1fr)] lg:gap-12 lg:py-14">
      <!-- Company and contact -->
      <section [attr.aria-label]="'Dane kontaktowe BROCOM' | translate" class="space-y-5">
        <img src="images/logo-light.webp" [alt]="'BROCOM' | translate" class="h-auto w-36" width="160" height="40" />
        <p class="text-sm leading-relaxed text-gray-300">{{ 'BROCOM INDUSTRY Sp. z o. o.' | translate }}</p>

        <address class="space-y-3 not-italic">
          <div *ngFor="let item of contactInfo" class="flex items-start gap-3">
            <img [src]="item.icon" class="mt-0.5 h-4 w-4 shrink-0 invert opacity-80" alt="" width="16" height="16"
              loading="lazy" />
            <span class="text-sm leading-5 text-gray-300">{{ item.title }}</span>
          </div>
        </address>

        <img src="/images/paynow-bannerbg.png" [alt]="'Metody płatności PayNow' | translate"
          class="h-auto w-full max-w-[18rem] rounded-lg" width="278" height="46" loading="lazy" />
      </section>

      <!-- Mobile navigation accordion -->
      <nav [attr.aria-label]="'Nawigacja stopki' | translate" class="space-y-4 lg:hidden">
        <div *ngFor="let section of footerSections; let i = index" class="border-b border-gray-700 pb-4">
          <button type="button" (click)="toggleAccordion(i)" [attr.aria-expanded]="openHeaderIndex === i"
            [attr.aria-controls]="'footer-section-' + i"
            class="group flex w-full items-center justify-between text-left">
            <span class="text-base font-semibold text-white transition-colors group-hover:text-brocom-orange">
              {{ section.title | translate }}
            </span>
            <svg class="h-4 w-4 text-gray-400 transition-transform duration-300"
              [class.rotate-90]="openHeaderIndex === i" fill="none" stroke="currentColor" stroke-width="2"
              viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
            </svg>
          </button>
          <div [id]="'footer-section-' + i" [hidden]="openHeaderIndex !== i"
            class="mt-4 space-y-3 animate-in slide-in-from-top-2 duration-300">
            <a *ngFor="let link of section.links" [routerLink]="link.route" [queryParams]="link.queryParams"
              [fragment]="link.fragment"
              class="block text-sm text-gray-400 transition-colors hover:text-white">
              {{ link.label | translate }}
            </a>
          </div>
        </div>
      </nav>

      <!-- Desktop navigation -->
      <nav [attr.aria-label]="'Nawigacja stopki' | translate" class="hidden grid-cols-4 gap-6 lg:grid">
        <section *ngFor="let section of footerSections" class="space-y-4">
          <h2 class="notranslate inline-block border-b border-brocom-orange pb-2 text-sm font-semibold text-white">
            {{ section.title | translate }}
          </h2>
          <div class="space-y-3">
            <a *ngFor="let link of section.links" [routerLink]="link.route" [queryParams]="link.queryParams"
              [fragment]="link.fragment"
              class="block text-sm text-gray-400 transition-colors hover:text-white">
              {{ link.label | translate }}
            </a>
          </div>
        </section>
      </nav>

      <!-- Newsletter and social links -->
      <section [attr.aria-label]="'Bądźmy w kontakcie' | translate" class="space-y-5 md:col-span-2 lg:col-span-1">
        <div>
          <h2 class="inline-block border-b border-brocom-orange pb-2 text-sm font-semibold text-white">
            {{ 'Bądźmy w kontakcie' | translate }}
          </h2>
          <p class="mt-3 text-sm leading-relaxed text-gray-300">
            {{ 'Otrzymuj informacje o produktach i nowościach BROCOM INDUSTRY.' | translate }}
          </p>
        </div>

        <app-newsletter-signup [compact]="true"></app-newsletter-signup>

        <div class="flex flex-col gap-6 border-t border-gray-700 pt-5 sm:flex-row sm:items-start sm:justify-between lg:flex-col lg:gap-5">
          <div>
            <h3 class="mb-3 text-sm font-semibold text-white">{{ 'Obserwuj nas' | translate }}</h3>
            <div class="flex gap-3">
              <a href="#" [attr.aria-label]="'BROCOM na LinkedIn' | translate"
                class="flex h-10 w-10 items-center justify-center rounded-full bg-gray-700 transition-colors hover:bg-brocom-orange">
                <svg class="h-4 w-4 text-white" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a>
              <a href="#" [attr.aria-label]="'BROCOM na Facebooku' | translate"
                class="flex h-10 w-10 items-center justify-center rounded-full bg-gray-700 transition-colors hover:bg-brocom-orange">
                <svg class="h-4 w-4 text-white" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>
            </div>
          </div>
          <div>
            <h3 class="mb-3 text-sm font-semibold text-white">{{ 'Język' | translate }}</h3>
            <div class="footer-language-switcher">
              <app-language-switcher></app-language-switcher>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- Shopping benefits -->
    <section [attr.aria-label]="'Korzyści zakupów' | translate" class="border-t border-gray-700 py-7 sm:py-8">
      <div class="grid grid-cols-2 gap-x-4 gap-y-6 lg:grid-cols-4 lg:gap-6">
        <div class="flex items-center gap-3 lg:justify-center">
          <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brocom-orange">
            <svg class="h-4 w-4 text-white" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
            </svg>
          </span>
          <div><h3 class="text-xs font-semibold text-white sm:text-sm">{{ 'Autoryzowany dystrybutor' | translate }}</h3><p class="mt-1 text-xs text-gray-400">{{ 'Sprawdzona jakość' | translate }}</p></div>
        </div>
        <div class="flex items-center gap-3 lg:justify-center">
          <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brocom-orange">
            <svg class="h-4 w-4 text-white" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
            </svg>
          </span>
          <div><h3 class="text-xs font-semibold text-white sm:text-sm">{{ '100% oryginalne produkty' | translate }}</h3><p class="mt-1 text-xs text-gray-400">{{ 'Gwarancja oryginalności' | translate }}</p></div>
        </div>
        <div class="flex items-center gap-3 lg:justify-center">
          <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brocom-orange">
            <svg class="h-4 w-4 text-white" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 15v2m-6 4h12a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2Zm10-10V7a4 4 0 0 0-8 0v4h8Z" />
            </svg>
          </span>
          <div><h3 class="text-xs font-semibold text-white sm:text-sm">{{ 'Bezpieczne płatności' | translate }}</h3><p class="mt-1 text-xs text-gray-400">{{ 'Pełna ochrona transakcji' | translate }}</p></div>
        </div>
        <div class="flex items-center gap-3 lg:justify-center">
          <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brocom-orange">
            <svg class="h-4 w-4 text-white" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3 7.5h11.25v10.125H3V7.5Zm11.25 3h3.375L21 13.875v3.75h-6.75V10.5ZM7.5 20.25a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Zm10.5 0a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
            </svg>
          </span>
          <div><h3 class="text-xs font-semibold text-white sm:text-sm">{{ 'Darmowa dostawa' | translate }}</h3><p class="mt-1 text-xs text-gray-400">{{ 'Przy zamówieniach powyżej określonej wartości' | translate }}</p></div>
        </div>
      </div>
    </section>

    <!-- Legal links and copyright -->
    <div class="border-t border-gray-700 py-6">
      <div class="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <p class="text-center text-xs text-gray-400 md:text-left">
          {{ '© 2026 BROCOM INDUSTRY by BADFI TECH. Wszelkie prawa zastrzeżone.' | translate }}
        </p>
        <nav [attr.aria-label]="'Linki prawne' | translate" class="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs md:justify-end">
          <a routerLink="/about-us" class="text-gray-400 transition-colors hover:text-white">{{ 'O nas' | translate }}</a>
          <a routerLink="/legal/privacy-policy" class="text-gray-400 transition-colors hover:text-white">{{ 'Polityka prywatności' | translate }}</a>
          <a routerLink="/legal/terms-and-conditions" class="text-gray-400 transition-colors hover:text-white">{{ 'Regulamin' | translate }}</a>
          <a routerLink="/legal/cookie-policy" class="text-gray-400 transition-colors hover:text-white">{{ 'Polityka cookies' | translate }}</a>
        </nav>
      </div>
    </div>
  </div>
</footer>
